// material-ui
import { Box, Stack, CircularProgress, Typography } from "@mui/material";

export default function LoaderInside() {
	return (
		<Stack spacing={4}>
			<Box display="flex" flexDirection="column" alignItems="center">
				<CircularProgress size={60} />
				<Typography variant="caption" sx={{ mt: "2px" }}>
					Loading...
				</Typography>
			</Box>
		</Stack>
	);
}
``;
